module.exports = __webpack_public_path__ + "static/media/ICONO_SESION.3772adcd.png";